interface LocalCache<T = any> {
	age: number;
	expired_at: string; // iso string
	data: T;
}

export const useLocalCache = <T>(cname: string, age = 1000 * 60 * 24) => {
	// invoke cache
	const invoke = (): null | T => {
		const str = localStorage.getItem(cname);
		if (!str) return null;

		const data = JSON.parse(str) as LocalCache<T>;

		if (!data.data) return null;

		// check expired
		const now = new Date().getTime();
		const expired_at = new Date(data.expired_at).getTime();
		if (now > expired_at) {
			localStorage.removeItem(cname);
			return null;
		}

		return data.data;
	};

	// set cache
	const set = (data: T) => {
		const cache: LocalCache<T> = {
			age,
			expired_at: new Date(new Date().getTime() + age).toISOString(),
			data
		};

		localStorage.setItem(cname, JSON.stringify(cache));
	};

	// delete cache
	const del = () => {
		localStorage.removeItem(cname);
	};

	// sugar function
	const preferCache = async (renew: () => T | Promise<T>) => {
		const c = invoke();
		if (c) return c;

		const d = await renew();
		set(d);
		return d;
	};

	return {
		invoke,
		set,
		del,
		preferCache
	};
};
